module.exports = __webpack_public_path__ + "static/media/buy_start_service_teach_1.ee6f0a69.jpg";